import { putQueryParam, toUrlT } from '@execonline-inc/url';
import { Task } from 'taskarian';
import { callApi } from '../../../../../../../../../../Appy';
import { Link } from '../../../../../../../../../../Resource/Types';
import { setFilteredState, warnAndSetErrorState } from './Actions';
import { filterOptionsResourceDecoder } from './Decoder';
import { FilterError, Filtering, NewState } from './Types';

const urlTask = (endpoint: Link, state: Filtering): Task<FilterError, Link> =>
  toUrlT(endpoint.href)
    .map(putQueryParam(`filter[query]`, state.filterBy))
    .map((url) => ({
      rel: endpoint.rel,
      href: url.href,
      method: endpoint.method,
      type: endpoint.type,
    }));

export const fetchOptionsReaction = (
  endpoint: Link,
  state: Filtering,
  setState: (value: NewState) => void,
) =>
  urlTask(endpoint, state)
    .andThen(callApi(filterOptionsResourceDecoder, {}))
    .fork(warnAndSetErrorState(setState), setFilteredState(state, setState));
